// src/data/gyms/CheerUP.js
export const CheerUP = {
  id: "cheerup",
  name: "Cheer UP Athletics",
  color: "#F59E0B", // Bright Orange/Gold
  lightColor: "#FFFBEB",
  logo: "🆙",

  teams: [
    { id: "karma", name: "KARMA", level: "L2 Junior - D2 - Medium" },
    { id: "wicked", name: "WICKED", level: "L4.2 Senior - D2" },
    { id: "twilight", name: "TWILIGHT", level: "L1 Junior - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "11:00 AM",
      teamId: "karma",
      meet: "10:24 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "11:32 AM",
      teamId: "wicked",
      meet: "10:56 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:26 PM",
      teamId: "twilight",
      meet: "1:50 PM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:35 AM",
      teamId: "wicked",
      meet: "8:59 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "10:34 AM",
      teamId: "karma",
      meet: "9:58 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "12:07 PM",
      teamId: "twilight",
      meet: "11:31 AM",
      panel: "Hall A", // Found on Row 188
    },
  ],
};
